import React, {useEffect, useState} from "react";
import {useStore} from "../../../hooks/useStore";
import {SelectField} from "./FilterComponentStyles";
import {useObserver} from "mobx-react-lite";

const SubCompanyWorkTypeFilter = ({
    showAllOption = false,
    value,
    onChange,
    showLabel = true,
    marginBottom = "20px",
    dedicatedLabel = "Sabit",
    // Sabit entegre yalnız Vardiya Yönetimi'nde ayrı bir tip; diğer ekranlar iki seçenekte kalır.
    showDedicatedIntegrationOption = false,
    syncWithStore = true
}) => {
    const stores = useStore();
    const [initialValue, setInitialValue] = useState(value);

    useEffect(() => {
        if (!syncWithStore) return;
        if (stores.meStore.map.filters.workType) {
            setInitialValue(stores.meStore.map.filters.workType);
            onChange(stores.meStore.map.filters.workType);
        }
    }, []);

    const handleSubcompanyType = selectedValue => {
        if (syncWithStore) {
            stores.meStore.map.filters.workType = selectedValue;
        }
        onChange(selectedValue);
    };

    return useObserver(() => (
        <React.Fragment>
            {showLabel && <h5>Alt Firma Tipi</h5>}
            <SelectField
                value={syncWithStore ? value || initialValue || "dedicated" : value}
                data-testid="workTypeFilter"
                onChange={handleSubcompanyType}
                mb={marginBottom}
            >
                {showAllOption && (
                    <SelectField.Option value="all" data-testid="workTypeFilter_option">
                        Tümü
                    </SelectField.Option>
                )}
                <SelectField.Option value="pool" data-testid="workTypeFilter_option">
                    Havuz
                </SelectField.Option>
                <SelectField.Option value="dedicated" data-testid="workTypeFilter_option">
                    {dedicatedLabel}
                </SelectField.Option>
                {showDedicatedIntegrationOption && (
                    <SelectField.Option
                        value="dedicatedIntegration"
                        data-testid="workTypeFilter_option"
                    >
                        Sabit Entegre
                    </SelectField.Option>
                )}
            </SelectField>
        </React.Fragment>
    ));
};

export default SubCompanyWorkTypeFilter;
